<template>

  <div class="scroll-y custom-scrollbar">
    <transition name="fade" mode="out-in">
      <ion-row>
        <ion-col size="12" size-md="10" offset-md="1" size-lg="10" offset-lg="1" size-xl="8" offset-xl="2">
          <div class="padding">
            <div class="text-center">
              <h1 class="h1 text-center">Strefa wiedzy</h1>

              <!--filter form-->
              <form class="form form-filter-knowledge-zone mb-20">
                <div class="form-group">
                  <div v-if="loading_categories" class="text-center" style="width: 100%">
                    <span class="loader red"></span>
                  </div>
                  <div v-else class="select-wrapper">
                    <!--<span v-if="category == null" class="select-placeholder">Wybierz kategorię</span>-->
                    <select v-model="category" @change="getData">
                      <option :value="null">Wszystkie</option>
                      <option
                          v-for="(item,key) in categoriesCollection"
                          :key="key"
                          :value="item.id">{{ item.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </form>

            </div>
          </div>

          <div v-if="loading" class="loader-wrapper"><span class="loader red"></span></div>

          <transition name="long-fade">
            <div class="padding">
              <item-news
                  v-for="item in newsCollection"
                  :key="item.id"
                  :routeName="'KnowledgeZoneSingle'"
                  :slug="item.slug"
                  :title="item.title"
                  :thumbnail="item.thumbnail"
                  :excerpt="item.excerpt"
                  :date="item.createdAtDate"
                  :time="item.createdAtTime">
              </item-news>
            </div>
          </transition>
          <ion-row v-if="loading === false && newsCollection.length === 0">
            <ion-col size="12">
              <p class="text-center">Brak danych</p>
            </ion-col>
          </ion-row>
        </ion-col>
      </ion-row>
    </transition>
  </div>

</template>

<script>
import ItemNews from '../../../items/ItemNews'
import NewsServices from "../../../services/NewsServices"

export default {
  name: 'KnowledgeZoneList',
  components: { ItemNews },
  data () {
    return {
      loading: true,
      loading_categories: false,
      errors: [],
      // data from api
      categoriesCollection: [],
      newsCollection: []
    }
  },
  computed: {
    category: {
      set (selectedCategory) {
        this.$store.commit('USER_SET_KNOWLEDGE_ZONE_CATEGORY', selectedCategory)
      },
      get () {
        return this.$store.state.user.currentKnowledgeZoneCategory || null
      }
    }
  },
  methods: {
    getCategories () {
      this.loading_categories = true
      NewsServices.getKnowledgeZoneCategories()
          .then((response) => {
            this.categoriesCollection = response.data.data
            this.loading_categories = false
          })
    },
    getData () {
      this.loading = true
      NewsServices.getKnowledgeZone(this.category ? this.category : null)
          .then((response) => {
            this.newsCollection = response.data.data
            this.loading = false
          })
    }
  },
  mounted () {
    this.getCategories()
    this.getData()
  }
}
</script>